package com.shadowings.gero.presentation.ui

import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathParser
import androidx.compose.ui.unit.dp

val FilledHeartIcon: ImageVector by lazy {
    ImageVector.Builder(
        name = "FilledHeart",
        defaultWidth = 24.dp,
        defaultHeight = 24.dp,
        viewportWidth = 24f,
        viewportHeight = 24f
    ).addPath(
        pathData = PathParser().parsePathString(
            "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        ).toNodes(),
        fill = SolidColor(neutralBlack)
    ).build()
}

val GoogleIcon: ImageVector by lazy {
    ImageVector.Builder(
        name = "GoogleIcon",
        defaultWidth = 24.dp,
        defaultHeight = 24.dp,
        viewportWidth = 24f,
        viewportHeight = 24f
    ).apply {
        addPath(
            pathData = PathParser().parsePathString(
                "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            ).toNodes(),
            fill = SolidColor(androidx.compose.ui.graphics.Color(0xFF4285F4))
        )
        addPath(
            pathData = PathParser().parsePathString(
                "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            ).toNodes(),
            fill = SolidColor(androidx.compose.ui.graphics.Color(0xFF34A853))
        )
        addPath(
            pathData = PathParser().parsePathString(
                "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"
            ).toNodes(),
            fill = SolidColor(androidx.compose.ui.graphics.Color(0xFFFBBC05))
        )
        addPath(
            pathData = PathParser().parsePathString(
                "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            ).toNodes(),
            fill = SolidColor(androidx.compose.ui.graphics.Color(0xFFEA4335))
        )
    }.build()
}

